<template>
  <div>
    <h3>{{ $t("navigation." + ROUTE_LOGIN) }}</h3>
    <UserForm @userSubmitted="login" />
  </div>
</template>

<script>
import UserForm from "./UserForm";
import { ROUTE_LOGIN } from "./../../constants";

export default {
  name: "Login",
  components: { UserForm },
  data() {
    return {
      ROUTE_LOGIN
    };
  },
  computed: {
    validForm() {
      return true;
    }
  },
  methods: {
    login(user) {
      // LOGIN TEST
      this.$store.dispatch("login", {
        email: user.email,
        password: user.password
      });
    }
  }
};
</script>

<style lang="scss"></style>
